import { render } from "./PopupLive.vue?vue&type=template&id=6b27cd0f&scoped=true"
import script from "./PopupLive.vue?vue&type=script&lang=js"
export * from "./PopupLive.vue?vue&type=script&lang=js"

import "@css/popup.css?vue&type=style&index=0&id=6b27cd0f&scoped=true&lang=css"
import "./PopupLive.vue?vue&type=style&index=1&id=6b27cd0f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b27cd0f"]])

export default __exports__